'use client'
import dynamic from 'next/dynamic'
import React, { useState, useEffect, useRef } from 'react'
import { Dialog } from '@headlessui/react'
import { FaUser, FaWhatsapp } from 'react-icons/fa'
import { MdOutlinePhoneIphone, MdEmail } from 'react-icons/md'
import { AiFillWechat } from 'react-icons/ai'
import { IoLogoWhatsapp } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { FaLine, FaPhoneSquareAlt } from 'react-icons/fa'
import { RiArrowDropDownLine } from 'react-icons/ri'
import tailwindConfig from '@tailwind.config'
import { Combobox, Listbox } from "@headlessui/react"
import { countryCodes } from '@constants/countryCodes'
import { preferredContact } from '@constants/preferredContact';
import Image from 'next/image'
import Link from 'next/link'
import QRCodeGenerator from '@components/QRCodeGenerator'
import { company } from '@constants/company'

const ContactProjectCardSent = dynamic(() => import('@components/ContactProjectCardSent'), {
    ssr: false,
})


const ContactCardProject = ({ project, agent, dictionary, lang }) => {
    // console.log(agent)
    // const { data: session } = useSession()

    const [isSubmitting, setIsSubmitting] = useState(false)
    const [userId, setUserId] = useState(null)
    const [contact, setContact] = useState(preferredContact[lang][0])
    const [phone, setPhone] = useState('')
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [line, setLine] = useState('')
    const [wechat, setWechat] = useState('')
    const [message, setMessage] = useState(`${dictionary?.messagePromptProject || ''}`)
    const [hasEnquiry, setHasEnquiry] = useState(false)
    const [selectedCountry, setSelectedCountry] = useState(countryCodes[0].code)
    const [query, setQuery] = useState('')
        const [phoneQrIsOpen, setPhoneQrIsOpen] = useState(false)  
        const [waQrIsOpen, setWaQrIsOpen] = useState(false)  
        const [lineQrIsOpen, setLineQrIsOpen] = useState(false)  
        const [isCopied, setIsCopied] = useState(false);
        const spanRef = useRef(null);

    const filteredCountries =
        query === ''
            ? countryCodes
            : countryCodes.filter((country) => {
                return country.country.toLowerCase().includes(query.toLowerCase()) || country.code.toLowerCase().includes(query.toLowerCase())
            })

            
    const copyToClipboard = () => {
        if (spanRef && spanRef.current) {
          const tempInput = document.createElement('input');
          tempInput.value = agent.agentContact;
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand('copy');
          document.body.removeChild(tempInput);
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 2000); // Reset copied state after 2 seconds
        }
      };

    useEffect(() => {
        const setUserData = () => {
            const savedDetails = JSON.parse(localStorage.getItem('contactDetails'));

            if (savedDetails) {
                if (savedDetails.name && savedDetails.name !== '') {
                    setName(savedDetails.name);
                }
                if (savedDetails.selectedCountry && savedDetails.selectedCountry !== '') {
                    setSelectedCountry(savedDetails.selectedCountry);
                }
                if (savedDetails.phone && savedDetails.phone !== '') {
                    setPhone(savedDetails.phone);
                }
                if (savedDetails.email && savedDetails.email !== '') {
                    setEmail(savedDetails.email);
                }
                if (savedDetails.contact && savedDetails.contact !== '') {
                    setContact(savedDetails.contact);
                }
                if (savedDetails.line && savedDetails.line !== '') {
                    setLine(savedDetails.line);
                }
                if (savedDetails.wechat && savedDetails.wechat !== '') {
                    setWechat(savedDetails.wechat);
                }

            }
        }
        setUserData()
    }, [])

    const handleForm = async (e) => {
        e.preventDefault()

        const contactDetails = {
            name,
            selectedCountry,
            phone,
            email,
            contact,
            line,
            wechat
        };

        localStorage.setItem('contactDetails', JSON.stringify(contactDetails));

        const { sendProjectContactForm } = await import('@services/sendProjectContactForm')
        const result = await sendProjectContactForm(userId, name, selectedCountry, phone, email, message, project.id, contact, line, wechat)
        if (result.ok) {
            setHasEnquiry(true)
            setIsSubmitting(false)
            const { sendGAEvent } = await import('@next/third-parties/google')

            sendGAEvent({ 
                event: "lead_project_inquiry",
                user_email: email || 'not_provided',
                user_phonecall: `${selectedCountry}${phone?.replace(/[a-zA-Z\W]/g, '')}`,
                project_id: project.id,
                project_name: project.name,
                project_type: project.metaCategory,
                project_location: project.districts[0]?.subdistrictName?.['en'],
            })
        } else {
            setIsSubmitting(false)
        }
    }

    const selectTextOnClick = (e) => {
        e.target.select();
    };

    // const agent = {
    //     agentName: 'Uncle Agent',
    //     email: 'uncle@agent.com',
    //     line: 'line',
    //     whatsapp: 'whatsapp',
    //     phone: 'phone',
    // }

    return (
        <>
            {!hasEnquiry ? (
                <div className='sm:flex bg-[#F7F6F0] hidden relative w-full h-full flex-col overflow-hidden border-[1px] border-maincolor shadow-md rounded-sm'>
                    <div className='p-2 z-20 flex flex-col justify-between items-center'>
                        <div className='w-full'>
                            <h2 className='text-secondary font-semibold text-xl mb-1'>{dictionary.contactMeNow}</h2>
                            <div className='w-full flex flex-row'>
                                <div className='relative  w-[80px] h-[80px] aspect-[1/1] rounded-full border-[1px] border-third overflow-hidden'>
                                    <Image
                                        className='object-contain cursor-pointer'
                                        // src={agent.cover}
                                        src={`/images/author.jpg`}
                                        // width={imageWidth}
                                        // height={imageHeight}
                                        fill={true}
                                        alt={'Agency Logo'}
                                    />
                                </div>
                                <div className='flex flex-col justify-between pl-2'>
                                    <div className='flex flex-col h-full justify-evenly items-center'>
                                        <span className='text-maincolor font-semibold'>Property Pros Pattaya</span>
                                                                    <div className='flex flex-col'>
                                {company.whatsappUrl && (
                                    <button onClick={() => {setWaQrIsOpen(true)}} title='WhatsApp' href={`${company.whatsappUrl}`} className='flex flex-row my-1 justify-center w-full bg-gradient-to-r from-[#25D366] to-[#25de68] hover:from-[#25de68] hover:to-[#25D366] py-1 px-1 mx-[1px] items-center rounded-sm shadow-sm drop-shadow-md' >
                                        <IoLogoWhatsapp
                                            color={tailwindConfig.theme.extend.colors.light}
                                            size={24}
                                            className=''
                                        />
                                        <span className='w-[90px] text-center text-light font-semibold ml-2'>Whatsapp</span>
                                    </button>
                                )}
                                {company.lineUrl && (
                                    <button onClick={() => {setLineQrIsOpen(true)}} title='LINE' href={company.lineUrl} className='flex flex-row my-1 justify-center w-full inset-0  bg-gradient-to-r from-[#32CD32] to-[#2dbc2d] transition-colors hover:from-[#2dbc2d] hover:to-[#32CD32] py-1 px-1 mx-[1px] items-center rounded-sm shadow-sm drop-shadow-md' target="_blank">
                                        <FaLine
                                            color={tailwindConfig.theme.extend.colors.light}
                                            size={24}
                                            className=''
                                        />
                                        <span className='w-[90px] text-center text-light font-semibold ml-2'>LINE</span>
                                    </button>
                                )}
                                {company.phoneUrl && (
                                    <button onClick={() => {setPhoneQrIsOpen(true)}} title='Mobile' href={`${company.phoneUrl}`} className='flex flex-row my-1 justify-center w-full bg-gradient-to-r from-[#FF0000] to-[#e90b0b] hover:from-[#e90b0b] hover:to-[#FF0000] py-1 px-1 mx-[1px] items-center rounded-sm shadow-sm drop-shadow-md' target="_blank">
                                        <FaPhoneSquareAlt
                                            color={tailwindConfig.theme.extend.colors.light}
                                            size={24}
                                            className=''
                                        />
                                        <span className='w-[90px] text-center text-light font-semibold ml-2'>Phone</span>
                                    </button>
                                )}
                                <Dialog
                                    open={waQrIsOpen}
                                    onClose={() => setWaQrIsOpen(false)}
                                    className="relative z-50"
                                >
                                    <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                                    <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                                        <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-4">
                                            <Dialog.Title>
                                                <div className='flex flex-row justify-between items-center'>

                                                    <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-sm w-[30px] h-[30px]' onClick={() => {setWaQrIsOpen(false)}}>
                                                        <IoClose 
                                                            size={16}
                                                            color={tailwindConfig.theme.extend.colors.light}
                                                        />
                                                    </button>
                                                </div>
                                            </Dialog.Title>
                                            <div className='flex flex-col items-center'>
                                                <QRCodeGenerator dictionary={dictionary} url={`${company.whatsappUrl}`} />
                                                <div className='w-full flex flex-row justify-center items-center'>
                                                    <Link className='w-full bg-[#25D366] text-maincolor p-2 rounded-sm text-center' href={company.whatsappUrl}>{dictionary.openInWhatsapp}</Link>
                                                </div>
                                            </div>
                                        </Dialog.Panel>
                                    </div>
                                </Dialog>
                                <Dialog
                                    open={lineQrIsOpen}
                                    onClose={() => setLineQrIsOpen(false)}
                                    className="relative z-50"
                                >
                                    <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                                    <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                                        <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-4">
                                            <Dialog.Title>
                                                <div className='flex flex-row justify-between items-center'>
                                                    <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-sm w-[30px] h-[30px]' onClick={() => {setLineQrIsOpen(false)}}>
                                                        <IoClose 
                                                            size={16}
                                                            color={tailwindConfig.theme.extend.colors.light}
                                                        />
                                                    </button>
                                                </div>
                                            </Dialog.Title>
                                            <div className='flex flex-col items-center'>
                                                <QRCodeGenerator dictionary={dictionary} url={`${company.lineUrl}`} />
                                            </div>
                                        </Dialog.Panel>
                                    </div>
                                </Dialog>
                                <Dialog
                                    open={phoneQrIsOpen}
                                    onClose={() => setPhoneQrIsOpen(false)}
                                    className="relative z-50"
                                >
                                <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                                    <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
                                        <Dialog.Panel className="mx-auto max-w-sm rounded bg-white p-4">
                                            <Dialog.Title>
                                                <div className='flex flex-row justify-between items-center'>
                                                    <button title='Close QR Modal' className='bg-third hover:bg-[#b81435] duration-200 flex items-center justify-center rounded-sm w-[30px] h-[30px]' onClick={() => {setPhoneQrIsOpen(false)}}>
                                                        <IoClose 
                                                            size={16}
                                                            color={tailwindConfig.theme.extend.colors.light}
                                                        />
                                                    </button>
                                                </div>
                                            </Dialog.Title>
                                            <div className='flex flex-col items-center'>
                                                <QRCodeGenerator dictionary={dictionary} url={`${company.phoneUrl}`} />
                                                <div className='w-full flex flex-row justify-center items-center'>
                                                    <span ref={spanRef} className='text-maincolor'>{agent.agentContact}</span>
                                                    <button title='Click to copy to clipboard' onClick={copyToClipboard} className='bg-maincolor text-light p-2 rounded-sm ml-4'>{isCopied ? `${dictionary.copied}` : `${dictionary.copy}`}</button>
                                                </div>
                                            </div>
                                        </Dialog.Panel>
                                    </div>
                                </Dialog>
                            </div>
                                     
                                    </div>
                                </div>
                            </div>
                            <div className='mt-2'>
                                <span className='text-maincolor '>{company.email}</span>
                            </div>
                        </div>
                        <div className='w-full sm:flex hidden items-center justify-center my-4'>
                            <span className='border-[1px] border-forth w-full'></span>
                            <span className='text-sm text-maincolor mx-2'>{dictionary.or}</span>
                            <span className='border-[1px] border-forth w-full'></span>
                        </div>
                        <h2 className='text-maincolor text-center font-semibold'>{dictionary.requestDetails}</h2>
                            <form onSubmit={handleForm}>
                                <label className='text-secondary text-sm'>{dictionary.name}:</label>
                                <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                    <FaUser
                                        color={tailwindConfig.theme.extend.colors.secondary}
                                        size={24}
                                        className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                    />
                                    <input
                                        className='w-full border-none py-2 pl-10  leading-5 text-gray-900 focus:ring-0'
                                        placeholder={dictionary.name}
                                        type='text'
                                        name='name'
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required
                                    />
                                </div>
                                <label className='text-secondary text-sm'>{dictionary.preferredContact}:</label>
                                <Listbox value={contact} onChange={setContact}>
                                    <div className='z-1 relative w-full cursor-default rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                        <Listbox.Button className="relative w-full cursor-default rounded-sm bg-white py-2 pl-3 pr-10 text-left focus:shadow-md focus:outline-none " aria-label="Phone Dropdown">
                                            <span className="block truncate">{contact.name}</span>
                                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                                <RiArrowDropDownLine
                                                    color={tailwindConfig.theme.extend.colors.secondary}
                                                    size={32}
                                                />
                                            </span>
                                        </Listbox.Button>
                                        <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-sm bg-white py-1 shadow-md ring-1 ring-black ring-opacity-5 focus:outline-none  z-50" aria-label="Select Preferred Contact Method">
                                            {preferredContact[lang].map((cont, contIdx) => (
                                                <Listbox.Option
                                                    key={contIdx}
                                                    className={({ active }) =>
                                                        `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-gray-100 text-maincolor' : 'text-secondary'
                                                        }`
                                                    }
                                                    value={cont}
                                                    aria-label={cont}
                                                >
                                                    {({ selected }) => (
                                                        <>
                                                            <span
                                                                className={`block truncate ${selected ? 'font-medium' : 'font-normal'
                                                                    }`}
                                                            >
                                                                {cont.name}
                                                            </span>
                                                            {selected ? (
                                                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                                                
                                                                </span>
                                                            ) : null}
                                                        </>
                                                    )}
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                                {(contact.value == 'phone' || contact.value == 'whatsapp' || contact.value == 'viber') && (
                                    <>
                                        <label className='text-secondary text-sm'>{dictionary.phone}:</label>
                                        <div className='flex flex-row w-full'>
                                            <Combobox className="w-1/4"
                                                value={selectedCountry}
                                                onChange={setSelectedCountry}
                                            >
                                                <div className="relative w-full">
                                                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                        <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10  leading-5 text-gray-900 focus:ring-0' aria-label="Phone Number Input" />
                                                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center py-2 pr-2" aria-label="Select Country Dropdown">
                                                            <RiArrowDropDownLine
                                                                color={tailwindConfig.theme.extend.colors.secondary}
                                                                size={24}
                                                            />
                                                        </Combobox.Button>
                                                    </div>
                                                    <Combobox.Options
                                                        as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                                                        className='z-50 left-0 right-0 absolute bg-white h-auto w-[300px] max-h-[200px] overflow-y-auto shadow-md rounded-sm py-1'
                                                        aria-label="Country Code Select"
                                                    >
                                                        {filteredCountries.map((country) => (
                                                            <Combobox.Option
                                                                key={country.id}
                                                                value={country.code}
                                                                className='py-2 px-4 cursor-pointer color-secondary z-50'
                                                            >
                                                                {country.code} {country.country}
                                                            </Combobox.Option>
                                                        ))}
                                                    </Combobox.Options>
                                                </div>
                                            </Combobox>
                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                                <MdOutlinePhoneIphone
                                                    color={tailwindConfig.theme.extend.colors.secondary}
                                                    size={24}
                                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                />
                                                <input
                                                    className='w-full border-none py-2 pl-10  leading-5 text-gray-900 focus:ring-0'
                                                    placeholder={`${dictionary.phone}`}
                                                    required
                                                    type='text'
                                                    name='phone'
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                                {(contact.value == 'line') && (
                                    <>
                                        <label className='text-secondary '>{dictionary.line}:</label>
                                        <div className='w-full py-1'>
                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm shadow-md bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2  mb-2'>
                                                <FaLine
                                                    color={tailwindConfig.theme.extend.colors.secondary}
                                                    size={24}
                                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                />
                                                <input
                                                    className='w-full border-none py-2 pl-10  leading-5 text-gray-900 focus:ring-0'
                                                    placeholder={dictionary.linePlaceholder}
                                                    type='line'
                                                    name='line'
                                                    value={line}
                                                    onChange={(e) => setLine(e.target.value)}
                                                    required
                                                    aria-label="LINE ID Input"
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                                {(contact.value == 'wechat') && (
                                    <>
                                        <label className='text-secondary '>{dictionary.wechat}:</label>
                                        <div className='w-full py-1'>
                                            <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm shadow-md bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2  mb-2'>
                                                <AiFillWechat
                                                    color={tailwindConfig.theme.extend.colors.secondary}
                                                    size={24}
                                                    className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                                />
                                                <input
                                                    className='w-full border-none py-2 pl-10  leading-5 text-gray-900 focus:ring-0'
                                                    placeholder={dictionary.wechatPlaceholder}
                                                    type='wechat'
                                                    name='wechat'
                                                    value={wechat}
                                                    onChange={(e) => setWechat(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                                <label className='text-secondary text-sm'>{dictionary.email}:</label>
                                <div className='w-full'>
                                    <div className='z-1 relative w-full cursor-default overflow-hidden rounded-sm bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                                        <MdEmail
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                            size={24}
                                            className='absolute inset-y-0 left-2 top-1 flex items-center pr-2'
                                        />
                                        <input
                                            className='w-full border-none py-2 pl-10  leading-5 text-gray-900 focus:ring-0'
                                            placeholder={`${dictionary.email}`}
                                            type='email'
                                            name='email'
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                <label className='text-secondary sm'>{dictionary.message}:</label>
                                <div className='w-full py-1'>
                                    <textarea
                                        className='w-full border-[1px] border-forth text-secondary rounded-sm p-2 '
                                        placeholder='Please enter your question on request'
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        rows={3}
                                        required
                                    />
                                </div>
                                <button disabled={isSubmitting} className='w-full p-2 bg-third hover:bg-maincolor delay-300 text-light font-bold rounded-sm  shadow-[0_8px_30px_rgb(0,0,0,0.12)]' type='submit'>{dictionary.send}</button>
                            </form>
                    </div>

                </div>) : (
                <ContactProjectCardSent enquiryId={project.enquiryId} projectId={project.id} email={email} dictionary={dictionary} />
            )}
        </>
    )
}

export default ContactCardProject